if (!customElements.get('dh-product-facts')) {
  customElements.define('dh-product-facts', class extends HTMLElement {
    connectedCallback() {
      const product = this.closest('.product');
      if (!product || product.classList.contains('product--no-media') || this.closest('quick-add-modal')) return;
      const info = product.querySelector('product-info');
      if (!info) return;
      this.entries = [...info.children]
        .filter(node => node.matches('.wine-reviews,.food-pairing,.wine-grapes,.vivino-rating,.product__description-block'))
        .sort((a, b) => Number(a.matches('.product__description-block')) - Number(b.matches('.product__description-block')))
        .map(node => {
          const anchor = document.createComment('dh-product-fact');
          node.before(anchor);
          return { node, anchor };
        });
      this.desktop = matchMedia('(min-width: 990px)');
      this.updateLayout = () => {
        this.entries.forEach(({ node, anchor }) => {
          if (this.desktop.matches) this.append(node);
          else anchor.after(node);
        });
      };
      this.desktop.addEventListener('change', this.updateLayout);
      this.updateLayout();
    }

    disconnectedCallback() {
      this.desktop?.removeEventListener('change', this.updateLayout);
      this.entries?.forEach(({ node, anchor }) => {
        if (anchor.isConnected) anchor.after(node);
        anchor.remove();
      });
      this.entries = [];
    }
  });
}
